/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {
	BaseComponent
} from "@intuitionrobotics/thunderstorm/frontend";
import {GenericSelect} from "@intuitionrobotics/thunderstorm/app-frontend/components/GenericSelect";
import {
	Frequency,
	TimeUnit
} from "@app/app-shared/care_config";
import * as React from "react";
import {COLORS} from "@res/colors";
import {FONTS} from "@res/fonts";
import {ICONS} from "@res/icons";

type Props = {
	label: string;
	frequency: Frequency;
	range: {
		start: number;
		end: number;
	},
	timeUnits: TimeUnit[],
	onFrequencyChange: (frequency: Frequency) => void;
}

type State = {}

const dropdownStyle = {
	option: (provided: any) => ({
		...provided,
		backgroundColor: "unset",
		color: COLORS.grays_dark,
		":hover": {
			backgroundColor: COLORS.grays_1
		}
	}),
	menu: (provided: any) => {
		return {
			...provided,
			marginBottom: 4,
			position: "fixed",
			top: "unset",
			width: "85px",
			zIndex: 1,
			boxsizing: "border-box",
			boxShadow: `1px 1px 6px 0 rgba(0, 0, 0, 0.3)`
		};
	},
	menuList: (provided: any) => {
		return {
			...provided,
			maxHeight: "150px"
		};
	},
	valueContainer: (provider: any) => ({
		...provider,
		minWidth: "30px"
	})
};

export class FrequencySelector
	extends BaseComponent<Props, State> {

	constructor(props: Props) {
		super(props);
	}

	render = () => {
		return <div style={{display: "flex", margin: 16, marginBottom: 0}}>
			<GenericSelect
				options={this.getOptions(this.props.frequency.value)}
				selectedOption={this.props.frequency.times}
				iconClose={this.iconArrow()}
				iconOpen={this.iconArrow()}
				onChange={(frequency: number) => this.props.onFrequencyChange({...this.props.frequency, times: frequency})}
				styles={{fontSize: 14, color: COLORS.neutral_text_dark, ...dropdownStyle, border: "solid", borderWidth: "1px", borederColor: "#ececee"}}
				presentation={o => o.toString()}/>
			{FONTS.reg_14(`${this.props.frequency.times === 1 ? "time a" : "times a"}`, {margin: "12px", color: COLORS.neutral_text_dark})}
			<div style={{width: "100px"}}>
				<GenericSelect
					options={this.props.timeUnits}
					selectedOption={this.props.frequency.value}
					iconClose={this.iconArrow()}
					iconOpen={this.iconArrow()}
					onChange={(unit: TimeUnit) => {
						const opts = this.getOptions(unit);
						if (!opts.find(o => o === this.props.frequency.times))
							this.props.onFrequencyChange({...this.props.frequency, times: 1, value: unit});
						else
							this.props.onFrequencyChange({...this.props.frequency, value: unit});
					}}
					styles={{fontSize: 14, color: COLORS.neutral_text_dark, ...dropdownStyle, border: "solid", borderWidth: "1px", borederColor: "#ececee"}}
					presentation={o => o.toString()}/>
			</div>

		</div>;
	};

	private iconArrow = () => {
		return <div style={{backgroundColor: COLORS.primary_blue_10, width: "16px", height: "16px", borderRadius: 12}}>
			{ICONS.icon_arrow_down(COLORS.primary_dark_blue, 16)}
		</div>;
	};

	private getOptions = (value: TimeUnit) => {
		return Array.from(Array(this.props.range.end - this.props.range.start).keys()).map(v => v + this.props.range.start);
	};

}
